/// <amd-module name="VSSUI/Components/Panel/PanelContent" />
import * as React from "react";

import { SurfaceContext } from "VSSUI/Surface";
import { css } from "VSSUI/Util";

import { IPanelContentProps } from "VSSUI/Components/Panel/Panel.Props";

export const PanelContent: React.SFC<IPanelContentProps> = props => {
    return (
        <SurfaceContext.Consumer>
            {surfaceContext => (
                <div className={css(props.className, "bolt-panel-content flex-row flex-grow scroll-auto", surfaceContext.horizontalClassName)}>
                    {props.children}
                </div>
            )}
        </SurfaceContext.Consumer>
    );
};
